export const blockIconsEditorFormatListBulleted = (
	<span className='material-symbols-outlined'>format_list_bulleted</span>
);
